function Item({ label, value, onChange, readOnly = false, containerStyle = {} }) {
  return (
    <div style={{ marginBottom: '15px', ...containerStyle }}>
      <label style={{ color: '#aaa', fontSize: '12px' }}>{label}</label><br />
      <input
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        style={{
          color: "#061B2B",
          fontWeight: "bold",
          fontSize: "14px",
          textAlign: "left",
          border: "1px solid #EBEBED",
          borderRadius: "4px",
          width: "100%",
          height: "35px",
          paddingLeft: "10px",
          backgroundColor: readOnly ? "#f5f5f5" : "#fff"
        }}
      />
    </div>
  );
}

export default Item;